import { InlineOption } from "@/Common/Components/Inputs/InlineOptionsControl";
import { UserPermissionFlags } from "@/Common/Models/Portal/MedfarPortal";

class RelationsHelper {
    public static getPermissionsOptions(): InlineOption<UserPermissionFlags>[] {
        return [
            new InlineOption(UserPermissionFlags.Profile, cacheStore.GetString("ProfileInformationLabel")),
            new InlineOption(UserPermissionFlags.Appointment, cacheStore.GetString("AppointmentsLabel")),
            new InlineOption(UserPermissionFlags.Document, cacheStore.GetString("DocumentsLabel")),
            new InlineOption(UserPermissionFlags.Message, cacheStore.GetString("MessagesLabel")),
            new InlineOption(UserPermissionFlags.Billing, cacheStore.GetString("BillingLabel"))
        ];
    }

    public static getAllPermissionsArray(): UserPermissionFlags[] {
        return Object.keys(UserPermissionFlags).map(k => Number(k)).filter(k => !isNaN(k) && k > 0);
    }

    public static hasFlag(value: UserPermissionFlags, flagToCheck: UserPermissionFlags): boolean {
        if (value & flagToCheck)
            return true;

        return false;
    }

    public static getPermissionsArray(permissions: UserPermissionFlags): UserPermissionFlags[] {
        return this.getAllPermissionsArray().filter(p => this.hasFlag(permissions, p));
    }

    public static mergeFlags(flags: UserPermissionFlags[]): UserPermissionFlags {
        let result = UserPermissionFlags.None;
        flags.forEach(flag => result = result | flag);
        return result;
    }
}

export { RelationsHelper };
